import { BacktestPanel } from "../components/BacktestPanel";
import { MarketDataPanel } from "../components/MarketDataPanel";

export function BacktestPage() {
  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-xl font-bold tracking-tight">Backtest</h1>
      <BacktestPanel />
      <MarketDataPanel />
    </div>
  );
}
